import getAPIMap from "../api_map.js";
import axios from "axios";
import getIP from "../getIP.js";
const IP = getIP();

export const getUser = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1].token}`,
    },
  };

  var url = IP + getAPIMap("getuserid");
  url = url.replace("{id}", queryKey[1].sub);
  let response = await axios.get(url, config);
  return response;
};

export async function clientSecret({ queryKey }) {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1].token}`,
    },
  };
  var url = IP + getAPIMap("clientSecret");
  let response = await axios.put(url, { clientId: queryKey[1].sub }, config);

  return response;
}
